import IconLeft from '@/assets/icons/iconArrowLeft.svg';
import IconRight from '@/assets/icons/iconRightLeft.svg';

export interface SliderPaginationButtonsProps {
  handlePrev: () => void;
  handleNext: () => void;
  disabled?: boolean;
}

export const SliderPaginationButtons = ({
  handlePrev,
  handleNext,
  disabled,
}: SliderPaginationButtonsProps) => (
  <div className="mt-6 flex w-full justify-center gap-4">
    <button
      className="bg-custom-base-inverse-primary hover:bg-custom-base-inverse-secondary flex h-[56px] w-[56px] cursor-pointer items-center justify-center rounded-full transition-colors duration-300"
      onClick={handlePrev}
      disabled={disabled}
      aria-label="previous slide"
    >
      <IconLeft />
    </button>

    <button
      className="bg-custom-base-inverse-primary hover:bg-custom-base-inverse-secondary flex h-[56px] w-[56px] cursor-pointer items-center justify-center rounded-full transition-colors duration-300"
      onClick={handleNext}
      disabled={disabled}
      aria-label="next slide"
    >
      <IconRight />
    </button>
  </div>
);
